import { GetCurrencySymbol } from '../../utils/Currency';
import { GetFloatNumber, GetNumberToWords } from '../../utils/NumberFormatter';

function CalculationArea({ info }) {
    const { amountBilled, currency } = info?.invoice || {};
    return (
        <div className="mb-6 mx-5 print:mx-0">
            <div className="flex items-stretch rounded-10">
                <div className="w-[calc(100%_-_200px)] bg-[#F5F6F7] py-3 px-7 rounded-tl-10 rounded-bl-10">
                    <div className="flex items-center gap-x-12">
                        <div className="w-[130px]">
                            <p className="font-normal">Subtotal</p>
                            <h2 className="text-2xl text-primary-700 font-normal">
                                <span>
                                    {GetCurrencySymbol(currency)}
                                    {GetFloatNumber(amountBilled) || '000000'}
                                </span>
                            </h2>
                        </div>

                        <div className="w-[calc(100%_-_130px)] font-normal text-primary-700 text-lg capitalize">
                            <h2 className="text-sm text-primary-700 font-normal">
                                <span>In Words</span>
                            </h2>
                            <span>
                                {GetNumberToWords(amountBilled) || 0} {currency} only
                            </span>
                        </div>
                    </div>
                </div>
                <div className="w-[200px] bg-[#525E67] text-white text-right py-3 px-5 rounded-tr-10 rounded-br-10">
                    <p className="font-extralight">Total</p>
                    <h2 className="text-2xl font-normal">
                        <span>
                            {GetCurrencySymbol(currency)}
                            {GetFloatNumber(amountBilled) || '000000'}
                        </span>
                    </h2>
                </div>
            </div>
            <p className="text-sm text-primary-700 opacity-70 text-right mt-1">
                Amount to be paid*
            </p>
        </div>
    );
}

export default CalculationArea;
